
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/auth";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  // Ajouter des logs pour déboguer le problème de redirection
  console.log("ProtectedRoute check:", {
    isAuthenticated, 
    isLoading,
    currentPath: window.location.pathname,
    hash: window.location.hash,
    href: window.location.href
  });

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#00123A]/5 to-[#FCACF4]/10">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-12 w-12 animate-spin text-[#00123A]" />
          <p className="text-lg text-[#00123A]">Vérification de l'accès...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log("User not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render children
  return <>{children}</>;
}
